var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content-header bg-white"},[_c('div',{staticClass:"bg-black bg-opacity-50"},[_c('div',{staticClass:"container text-center h-48 flex"},[_c('h1',{staticClass:"text-white font-bold text-5xl m-auto"},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }